import { useContext, useMemo, useState } from 'react'
import { __ } from '@wordpress/i18n'
import Button from '../../Common/Button';
import Source from '../../Common/Source';
import ModalContainer from '../../Global/ModalContainer';
import AddSourceModal from '../../Modals/AddSourceModal';
import SbUtils from '../../../Utils/SbUtils';

const SelectSourcesSection = (props) => {

    const {
        sources,
        editorNotification,
        sbCustomizer,
        upsellModal
    } = useContext(SbUtils.getCurrentContext());

    const disableAddSources = SbUtils.checkSourceLimitReached(sources.sourcesList.length);

    // if newSourceData is not empty, then add the new source to the sources list
    useMemo(() => {
        if (sbCustomizer.newSourceData !== undefined && sbCustomizer.newSourceData !== null) {
            // check if the new source is already in the sources list
            const sourceExists = sources.sourcesList.find(source => source.open_id === sbCustomizer.newSourceData.open_id);
            if (sourceExists === undefined){
                sources.setSourcesList([...sources.sourcesList, sbCustomizer.newSourceData]);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sbCustomizer.newSourceData]);


    const [addSourcesModalActive, setAddSourcesModalActive] = useState(false);
    const [collapsedSources, setCollapsedSources] = useState([]);

    const addSourcePopup = () => {
        setAddSourcesModalActive(true)
    }
    return (
        <>
            <div
                className={'sb-' + props.context + '-content sb-fs'}
                data-context={props.context}
            >
                {
                    sources.sourcesList.length !== 0 &&
                    <div className='sb-sources-list sb-fs'>
                        <Button
                            text={__('Add Source', 'sb-customizer')}
                            icon='plus'
                            customClass={`sb-addnew-source ${disableAddSources ? 'sb-btn-disabled' : ''}`}
                            boxshadow={false}
                            size='small'
                            iconSize='14'
                            fontSize='14px'
                            onClick={() => {
                                if (disableAddSources) {
                                    SbUtils.openUpsellModal('sourcesLimitModal', upsellModal)
                                } else {
                                    addSourcePopup()
                                }
                            }}
                        />
                        {
                            sources.sourcesList.map((source, sourceInd) => {
                                const sourceInfo = source?.info !== '' && source?.info !== null && source?.info !== undefined ? JSON.parse(source?.info) : null;
                                return (
                                    <Source
                                        key={sourceInd}
                                        checkbox={props.context !== 'settingspage' && true}
                                        isChecked={props.context !== 'settingspage' && props.selectedSources.includes(source.open_id)}
                                        name={source.display_name}
                                        removeIcon={props.context === 'settingspage'}
                                        infoIcon={props.context === 'settingspage'}
                                        openId={source.open_id}
                                        avatar={sourceInfo?.local_avatar_url || sourceInfo?.avatar_url}
                                        editorNotification={editorNotification}
                                        isCollapsed={collapsedSources.includes(source.open_id)}
                                        onRemoveClick={() => {
                                            props.context === 'settingspage' &&
                                                props.deleteSource(source);
                                        }}
                                        onClick={() => {
                                            props.context !== 'settingspage' &&
                                                props.selectSourcesAction(source.open_id);
                                        }}
                                        onShowInfoClick={() => {
                                            setCollapsedSources([...SbUtils.updateArray(source.open_id, collapsedSources)]);
                                        }}


                                    />
                                )
                            })
                        }
                    </div>
                }
                {
                    sources.sourcesList.length === 0 &&
                    <div className='sb-emptysources-notice'>
                        <span className='sb-fs sb-text-small sb-dark-text'>{__('Looks like you have not added any source. Use “Add Source” to add a new one.', 'sb-customizer')}</span>
                        <Button
                            text={__('Add Source', 'sb-customizer')}
                            type='secondary'
                            size='medium'
                            icon='plus'
                            boxshadow={false}
                            iconSize='14'
                            onClick={() => {
                                addSourcePopup()
                            }}
                        />
                    </div>
                }
            </div>
            {
                addSourcesModalActive &&
                <ModalContainer
                    size='small'
                    closebutton={false}
                >
                    <AddSourceModal
                        openDialog={() => {
                            setAddSourcesModalActive(true)
                        }}
                    />
                </ModalContainer>
            }
        </>
    )
}

export default SelectSourcesSection;